var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZone2Path(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3840 2329",
    style: {
      enableBackground: "new 0 0 3840 2329"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "z2_path"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00A3DE",
      strokeWidth: 49.9449,
      strokeMiterlimit: 10
    },
    d: "M2586.602,2055.088 c-19.958,2.094-39.778,3.722-59.175,4.752c-191.945,10.195-328.458-62.048-328.458-62.048s-34.743-19.653-139.994-15.605 s-256.456-18.919-377.717-137.792c-121.261-118.873-339.557-274.01-599.53-159.862s-522.527,86.553-649.302-49.958 c0,0-37.244-152.719,15.758-245.707s159.88-137.509,189.576-149.833c28.105-11.664,130.783-55.158,86.501-174.811"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone2Path);
export default __webpack_public_path__ + "static/media/zone2-path.1b24d88a.svg";
export { ForwardRef as ReactComponent };